import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './BasePaywall';
import { AppState } from '../../../../../../types/store';
import {
  isCurrentUserProfileOwner,
  isViewingAsVisitor,
} from '../../../../../selectors/users';

export type StateProps = Pick<
  Props,
  'isCurrentUserProfileOwner' | 'isViewingAsVisitor'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
  isViewingAsVisitor: isViewingAsVisitor(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
